import gql from 'graphql-tag';

const GET_ALERT_HISTORY = gql`
  query GetAlertHistory($orderBy: SystemAlertOrderByInput) {
    systemAlerts(orderBy: $orderBy) {
      id
      type
      message
      link
      linkText
      dismissible
      active
      deleted
      startDate
      endDate
      priority
      createdBy {
        id
        username
        name
      }
      createdAt
      updatedBy {
        id
        username
        name
      }
      updatedAt
      deletedBy {
        id
        username
        name
      }
      deletedAt
    }
  }
`;

export default GET_ALERT_HISTORY;
